import { useNavigate, useParams } from 'react-router-dom';
import { useCreateMentorshipMutation } from '../useCreateMentorshipMutation';
import { useMentorshipPayload } from '../useMentorshipPayload';
import { useUpdateMentorshipMutation } from '../useUpdateMentorshipMutation';
import { DrawerHelper } from 'src/shared/components/drawer/helper';
import { Routes } from 'src/shared/constants/routes';
import { removeMentorshipQueries } from './removeMentorshipQueries';
export function useSubmitMentorship({ isUpdate, onSubmitSuccess }) {
    const navigate = useNavigate();
    const { mentorshipId } = useParams();
    const { mapMentorshipFormValuesToPayload } = useMentorshipPayload();
    const createMentoshipMutation = useCreateMentorshipMutation();
    const updateMentorshipMutation = useUpdateMentorshipMutation(mentorshipId || '');
    const submitMutation = isUpdate ? updateMentorshipMutation : createMentoshipMutation;
    function success({ mentorshipId }) {
        removeMentorshipQueries(mentorshipId);
        const redirectToModulesList = () => {
            navigate({
                pathname: Routes.ListModules
            });
        };
        DrawerHelper.listenerOnClose(redirectToModulesList);
        onSubmitSuccess();
    }
    const submit = (formData) => {
        const payload = mapMentorshipFormValuesToPayload(formData);
        submitMutation.mutate(payload, {
            onSuccess: (data) => {
                success({
                    mentorshipId: data.id || mentorshipId
                });
            }
        });
    };
    return { submit, isPending: submitMutation.isPending };
}
